import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { BusinessMaps } from '../components/BusinessMaps';
import { ArrowLeftIcon, MapIcon } from 'lucide-react';
export function BusinessMapPage() {
  const {
    language
  } = useLanguage();
  const isEs = language === 'ES';
  return <div className="min-h-screen bg-gray-50 font-nunito" data-id="element-3445" data-mp="3pf9wm3gyb5lm">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm" data-id="element-3446" data-mp="2rqzttm9ccdtg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between" data-id="element-3447" data-mp="2rp56y2eiebmq">
          <div className="flex items-center gap-4" data-id="element-3448" data-mp="31p5tdx7od7v5">
            <button onClick={() => {
            window.location.hash = '';
          }} className="inline-flex items-center gap-2 text-haa-navy hover:text-haa-blue transition-colors font-nunito font-bold text-sm" data-id="element-3449" data-mp="31odxela6184c">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-3450" data-mp="2908bhv7dld2x" />
              {isEs ? 'Volver al Inicio' : 'Back to Home'}
            </button>
          </div>
          <div className="flex items-center gap-3" data-id="element-3451" data-mp="2k4ub38rorzcs">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-haa-navy to-haa-blue flex items-center justify-center shadow-md" data-id="element-3452" data-mp="2k4c87taiqmvw">
              <MapIcon className="w-5 h-5 text-white" data-id="element-3453" data-mp="2af128fixhyc8" />
            </div>
            <div data-id="element-3454" data-mp="2ad7tmuor941l">
              <h1 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider leading-none" data-id="element-3455" data-mp="25g7n6inztz9y">
                {isEs ? 'Mapa de Empresas Hondureño-Americanas' : 'Honduran-American Business Map'}
              </h1>
              <p className="font-nunito text-xs text-gray-500 mt-0.5" data-id="element-3456" data-mp="1wf9toub6la5m">
                {isEs ? 'Honduran-American Association' : 'Honduran-American Association'}
              </p>
            </div>
          </div>
          <div className="w-[120px]" data-id="element-3457" data-mp="1miev6bewr9rc" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3458" data-mp="3ltxwq4xvtfqz">
        <BusinessMaps data-id="element-3459" data-mp="3gv4niopmoawm" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-haa-navy py-6 mt-12" data-id="element-3460" data-mp="1f67b26q098fh">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3461" data-mp="1f5feasko94nm">
          <p className="font-nunito text-sm text-white/60" data-id="element-3462" data-mp="1jx72wxk9p0b4">
            © {new Date().getFullYear()} Honduran-American Association
          </p>
        </div>
      </footer>
    </div>;
}